import { render, staticRenderFns } from "./SegmentListItem.vue?vue&type=template&id=83311222&scoped=true&"
import script from "./SegmentListItem.vue?vue&type=script&lang=js&"
export * from "./SegmentListItem.vue?vue&type=script&lang=js&"
import style0 from "./SegmentListItem.vue?vue&type=style&index=0&id=83311222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83311222",
  null
  
)

export default component.exports